export default __webpack_public_path__ + "static/media/support.570e3c66.svg";